export default __webpack_public_path__ + "static/media/link-chain.b5897c25.svg";